<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("visitor.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="px-1">
                <v-md-date-range-picker
                  date-format="DD/MM/YYYY"
                  @change="onDateChange"
                ></v-md-date-range-picker>
              </v-col>
             <v-col cols="12" sm="3" md="2" class="px-1">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto" class="px-2">
                <v-autocomplete
                  v-model="selected_flat"
                  label="Block"
                  :items="flats"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="
                    getVisitors();
                    getHouseNumber();
                  "
                ></v-autocomplete>
              </v-col>
              <v-col cols="auto" class="px-2">
                <v-autocomplete
                  v-model="house_number"
                  label="House"
                  :items="houseNumber"
                  item-text="house_number"
                  item-value="id"
                  outlined
                  dense
                  hide-details
                  clearable
                  @change="getVisitors()"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="visitors"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.profile_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.profile_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.profile_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">{{
                    item.name ? item.name.charAt(0) : ""
                  }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.name }}
              </template>
              <template v-slot:item.mobile_no="{ item }">
                {{ (item.country_code) }} {{ item.mobile_no }}
              </template>
              <template v-slot:item.flat_id="{ item }">
                {{
                  item.flat_no
                    ? item.flat_no + " - " + item.house_number
                    : item.house_number
                }}
              </template>
              <template v-slot:item.vehicle_no="{ item }">
                {{ item.vehicle_no ? item.vehicle_no : "N/A" }}
              </template>
              <template v-slot:item.number_of_visitors="{ item }">
                {{ item.number_of_visitors ? item.number_of_visitors : "N/A" }}
              </template>
              <template v-slot:item.visited_at="{ item }">
                {{ getFormattedDate(item.visited_at) }}
              </template>
              <template v-slot:item.status="{ item }">
                {{ item.status }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_visitor"
                  title="View Visitor"
                  style="margin-left: -10px"
                  :to="'/societyadmin/visitor/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      startVal: "",
      endVal: "",
      search: "",
      headers: [
        {
          text: `${this.$t("visitor.headers.profile_url")}`,
          value: "profile_url",
          sortable: false,
          search: false,
        },
        {
          text: `${this.$t("visitor.headers.name")}`,
          value: "name",
        },
        {
          text: `${this.$t("visitor.headers.mobile_no")}`,
          value: "mobile_no",
          class: "text-truncate",
        },
        {
          text: `${this.$t("visitor.headers.house_no")}`,
          value: "flat_id",
        },
        {
          text: `${this.$t("visitor.headers.number_of_visitors")}`,
          value: "number_of_visitors",
        },
        {
          text: `${this.$t("visitor.headers.vehicle_no")}`,
          value: "vehicle_no",
        },
        {
          text: `${this.$t("visitor.headers.visited_at")}`,
          value: "visited_at",
        },
        {
          text: `Status`,
          value: "status",
        },
        // {
        //   text: `${this.$t("visitor.headers.actions")}`,
        //   value: "actions",
        //   sortable: false,
        //   width: "15%",
        // },
      ],
      user: {},
      dateRange: null,
      addPermissionDialog: false,
      deleteDialog: false,
      visitors: [],
      delete_id: "",
      flats: [],
      houseNumber: [],

      selected_flat: "",
      house_number: "",

      options: {
        sortBy: ["created_at"],
      },
      totalRecords: 0,
      loading: false,
      page: 1,
      startDate:"",
      endDate:"",

      
    };
  },
  watch: {
    options: {
      handler() {
        this.getVisitors();
      },
      deep: true,
    },
  },
  methods: {
    onDateChange(event) {
      this.startDate = event[0].format("YYYY-MM-DD");
      this.endDate = event[1].format("YYYY-MM-DD");
      this.getVisitors();
    },
    clearDateRange() {
      setTimeout(() => {
              window.location.reload();
            });
      this.getVisitors();
    },
    ...mapMutations("alert", ["setAlert"]),
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    getVisitors() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc =
        this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let startDate = this.startDate
        ? moment(this.startDate).format("YYYY-MM-DD")
        : "";
      let endDate = this.endDate
        ? moment(this.endDate).format("YYYY-MM-DD")
        : "";
      this.$axios
        .get("societyadmin/visitors", {
          params: {
            society_id: this.user.id,
            flat_id: this.selected_flat,
            house_number: this.house_number,
            page,
            perPage: itemsPerPage,
            sortBy,
            sortDesc,
            search,
            startDate,
            endDate,
          },
        })
        .then((response) => {
          this.loading = false;
          let data = response.data;

          if (data.status) {
            this.visitors = data.visitors;
            this.totalRecords = data.total;
            this.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    getFlats() {
      let _self = this;
      _self.$axios.get("societyadmin/flats").then((response) => {
        let data = response.data;

        if (data.status) {
          let modifiedFlats = [...data.flats];
          modifiedFlats.unshift({ id: "single_house", name: "Single House" });
          _self.flats = modifiedFlats;
        } else {
          _self.setAlert({
            showAlert: true,
            variant: "red accent-3",
            timeout: "2000",
            message: data.message,
          });
        }
      });
    },
    getHouseNumber() {
      let _self = this;
      _self.$axios
        .get("societyadmin/houseNumber?flat_id=" + _self.selected_flat)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            _self.houseNumber = data.houses;
            console.log(data.houses);
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("visitor_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("visitor_search", trimmedSearch);
      }
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    debounceInput: debounce(function () {
      this.getVisitors();
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getFlats();
    this.getVisitors();
    this.search = sessionStorage.getItem("visitor_search");
  },
};
</script>
<style scoped>
.wrapper {
  max-width: 250px;
  margin: 0 auto;
}
.btn-class {
  margin-top: 4px;
  margin-left: -42px;
}
</style>
